import api from "./index";
import generateHeaders from "../utils/generateHeaders";

export const getAnalyticsCourseTotalActionsService = async ({ token }) => {
  const headers = generateHeaders(token);

  return await api.get("/academy/analytics/courses/actions", headers);
};

export const getAnalyticsCourseUsersService = async ({
  token,
  courseId,
  eventId,
  lessonId,
  year,
  startDate,
  endDate,
  page,
  perPage,
  sortBy = "name",
  sortDirection = "ASC",
}) => {
  const headers = generateHeaders(token);

  const params = {
    courseId,
    eventId,
    lessonId,
    year,
    startDate,
    endDate,
    page,
    size: perPage,
    sortBy,
    sortDirection,
  };
  const options = {
    ...headers,
    params,
  };

  return await api.get("/academy/analytics/courses/filter", options);
};

export const getAnalyticsBannerTotalActionsService = async ({ token }) => {
  const headers = generateHeaders(token);

  return await api.get("/academy/analytics/banners/actions", headers);
};

export const getAnalyticsBannerUsersService = async ({
  token,
  eventId,
  bannerId,
  year,
  startDate,
  endDate,
  page,
  perPage,
  sortBy = "name",
  sortDirection = "ASC",
}) => {
  const headers = generateHeaders(token);

  const params = {
    bannerId,
    startDate,
    endDate,
    eventId,
    year,
    page,
    size: perPage,
    sortBy,
    sortDirection,
  };

  const options = {
    ...headers,
    params,
  };

  return await api.get("/academy/analytics/banners/filter", options);
};
